import { WizardConfig } from "../../wizard.component";
import { DefineDutyComponent, TripSemantics } from "../create-rule/define-duty/define-duty.component";
import { GetStartedComponent } from "../create-rule/get-started/get-started.component";
import { init } from "../create-rule/init";
import { ReviewAndSubmitComponent } from "../create-rule/review-and-submit/review-and-submit.component";
import { getPayload as getPayloadEnd } from "./payload/define-duty-end.payload";
import { getPayload as getPayloadStart } from "./payload/define-duty-start.payload";

import { getValidatedElements as defineEndDuty_getValidatedComponents } from "./validators/define-duty-end.validator";
import { getValidatedElements as defineStartDuty_getValidatedComponents } from "./validators/define-duty-start.validator";

export const wizardConfig: WizardConfig[] = [
	{
		wizardId: "create-rule",
		title: "create rule",
		backToRoute: "/mir-rules",
		init,
		steps: [
			{
				label: "get started",
				component: GetStartedComponent,
				noResetBtn: true,
			},
			{
				label: "duty start",
				component: DefineDutyComponent,
				data: {
					semantics: TripSemantics.tripStart,
					wantMovementOption: true,
				},
				getValidatedElements: defineStartDuty_getValidatedComponents,
				getPayload: getPayloadStart,
			},
			{
				label: "duty end",
				component: DefineDutyComponent,
				data: {
					semantics: TripSemantics.tripEnd,
				},
				getValidatedElements: defineEndDuty_getValidatedComponents,
				getPayload: getPayloadEnd,
			},

			{
				label: "review and submit",
				component: ReviewAndSubmitComponent,
				noResetBtn: true,
			},
		],
	},
];
